export const updateRefundDays = async(
    token,
    refund_days,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_refund_days", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    refund_days: refund_days,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );

        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updatePickupRadius = async(
    token,
    pickup_radius,
    fetchData,
    setDisable4
) => {
    setDisable4(true);
    try {
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_pickup_radius", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    pickup_radius: pickup_radius,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable4(false);
        } else {
            //console.log('some error occurred');
            setDisable4(false);
        }
    } catch (error) {
        //console.log(error);
        setDisable4(false);
    }
};

export const updateRefRate = async(
    token,
    entity,
    refund_percent,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        //console.log(entity, refund_percent);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_refund_percent", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    refund_percent: refund_percent,
                    entity: entity,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateBaseFare = async(
    token,
    delivery_medium,
    base_fare,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_base_fare", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    base_fare: base_fare,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateKmRate = async(
    token,
    delivery_medium,
    km_rate,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_km_rate", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    km_rate: km_rate,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );

        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateTimeRate = async(
    token,
    delivery_medium,
    time_rate,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_time_rate", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    time_rate: time_rate,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        const result = await response.json();
        //console.log(result);
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateMinPrice = async(
    token,
    delivery_medium,
    min_price,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_min_price", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    min_price: min_price,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        const result = await response.json();
        //console.log(result);
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            setDisable(false);
            fetchData();
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateScheduleBaseFare = async(
    token,
    delivery_medium,
    base_fare,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_sdl_base_fare", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    sdl_base_fare: base_fare,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateScheduleKmRate = async(
    token,
    delivery_medium,
    km_rate,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_sdl_km_rate", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    sdl_km_rate: km_rate,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );

        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateScheduleTimeRate = async(
    token,
    delivery_medium,
    time_rate,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_sdl_time_rate", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    sdl_time_rate: time_rate,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        const result = await response.json();
        //console.log(result);
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updateScheduleMinPrice = async(
    token,
    delivery_medium,
    min_price,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_sdl_min_price", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    delivery_medium: delivery_medium,
                    sdl_min_price: min_price,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        const result = await response.json();
        console.log(result);
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            setDisable(false);
            fetchData();
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};
//update schedule rates



export const updatePickloadPercent = async(
    token,
    pickload_percent,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        //console.log(pickload_percent);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_pickload_percent", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    pickload_percent: pickload_percent,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            setDisable(false);
            fetchData();
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};


export const updateDeliveryWaitTime = async(
    token,
    delivery_wait_time,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        //console.log(delivery_wait_time);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_request_timeout_duration", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    duration: delivery_wait_time,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};

export const updatePaymentTimeoutDuration = async(
    token,
    payment_timeout_duration,
    fetchData,
    setDisable
) => {
    try {
        setDisable(true);
        //console.log(payment_timeout_duration);
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_payment_timeout_duration", {
                method: "POST",

                body: JSON.stringify({
                    token: token,
                    duration: payment_timeout_duration,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );
        if (response.status === 200) {
            //console.log('data gotten succesfully');
            fetchData();
            setDisable(false);
        } else {
            //console.log('some error occurred');
            setDisable(false);
        }
        const result = await response.json();
        //console.log(result);
    } catch (error) {
        //console.log(error);
        setDisable(false);
    }
};


// function for percentage discount
export const updatepercentageDiscount = async(
    token,
    discount_percentage,
    fetchData,
    setDisable,
    setCurrentDiscount

) => {
    try {
        setDisable(true);

        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/set_discount_setting", {
                method: "POST",
                body: JSON.stringify({
                    token: token,
                    discount_percent: discount_percentage, // Match the backend's key
                }),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json, text/plain, */*",
                },
            }
        );

        const result = await response.json(); // Parse response JSON
        console.log(result); // Debug response

        if (response.status === 200) {
            fetchData(); // Fetch updated data
            fetchCurrentDiscount(setCurrentDiscount); // Refresh current discount
            setDisable(false)
        }

        setDisable(false); // Re-enable button
    } catch (error) {
        console.error(error); // Log error
        setDisable(false); // Re-enable button on error
    }
};


// function to get current percetage status
export const fetchCurrentDiscount = async(setCurrentDiscount) => {
    try {
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/get_discount_status", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (response.status === 200) {
            const data = await response.json();
            
            setCurrentDiscount(data.discount_percentage);
        } else {
            console.error("Failed to fetch discount status");
        }
    } catch (error) {
        console.error("Error fetching discount status:", error);
    }
};




// Functiont to get the current status 
export const fetchDiscountStatus = async(setDiscountEnabled) => {
    try {
        const response = await fetch(
            "https://serverpickload.wl.r.appspot.com/admin_settings/get_discount_status", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            throw new Error("Failed to fetch discount status");
        }

        const data = await response.json();
        console.log('Discount Status:', data); // Check the server response
        console.log('Discount Status:', data); // Check the server response
        console.log('Discount Status:', data); // Check the server response

        setDiscountEnabled(data.discount_status); // Update the state with the response
    } catch (error) {
        console.error("Error fetching discount status:", error);
    }
};

// update discount Status
export const updateDiscountStatus = async(token, newState) => {
    try {
        const response = await fetch("https://serverpickload.wl.r.appspot.com/admin_settings/toggle_discount", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                token,
                discount_enabled: newState,
            }),
        });

        if (!response.ok) throw new Error("Failed to toggle discount status");

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error updating discount status:", error);
        throw error;
    }
};